<template>
  <v-container
    style="max-width: 1500px;padding-top: 20px; overflow-x: scroll; white-space: nowrap;display: flex; justify-content: center;"
  >
    <v-row style="    width: -webkit-fill-available;">
      <template v-for="n in news" flat v-show="news.length > 0">
        <div :key="n.forum_id" style="display:inline">
          <v-flex :key="n.forum_id" flat style="max-width:640px; margin:auto;">
            <v-card flat style=" background-color:#fff0">
              <v-carousel
                lazy
                class="elevation-5 carousel-concord"
                height="100%"
                style="border-radius: 10px 10px 0 0; "
                hide-delimiters
                :cycle="false"
              >
                <v-carousel-item
                  flat
                  v-bind="n"
                  v-for="(item, i) in n.items"
                  :key="i"
                  :src="item"
                  height="100%"
                  style="max-width: 700px"
                >
                  <v-btn
                    class="carousel-concord-btn primary lighten-2"
                    fab
                    dark
                    small
                    style="color: white;opacity:.8; float:right"
                  >
                    <span style="font-size:11px"
                      >{{ i + 1 }}/{{ n.items.length }}</span
                    >
                  </v-btn>
                </v-carousel-item>
              </v-carousel>
            </v-card>
          </v-flex>
          <v-card
            :key="n.forum_id"
            flat
            style="max-width: 640px;width: -webkit-fill-available; background: #00008b00; margin:auto"
          >
            <v-card
              :key="n.forum_id"
              class="elevation-5"
              style=" background-color: #56585b; border-radius: 0 0 10px 10px; margin-bottom:25px; padding-bottom: 1px;"
            >
              <h1>
                <v-subheader
                  style="background-color:#6aaaff05; padding: 40px; justify-content: space-evenly;"
                >
                  <h2
                    class="font-weight-bold"
                    style="color: white; bottom: 20px; overflow-wrap: break-word;  white-space: normal;  text-align: center; text-transform: capitalize;"
                  >
                    {{ n.title }}
                  </h2>
                </v-subheader>
              </h1>

              <v-layout
                row
                style="padding: 0% 2% 3%; text-align:center;display: block;"
              >
                <v-list
                  style=" padding-top:0; padding-bottom: 0; background-color:#6aaaff05"
                >
                  <div>
                    <v-btn
                      :key="n.forum_id"
                      flat
                      lighten-2
                      class="success"
                      style="border-radius: 20px; height:30px; min-width:75px; color:white"
                      @click="accept(n.forum_id)"
                    >
                      <v-icon dark style="font-size:22px; ">done</v-icon>
                      &nbsp;&nbsp; Accept
                    </v-btn>
                    <v-btn
                      :key="n.forum_id"
                      flat
                      lighten-2
                      class="danger"
                      style="border-radius: 20px; height:30px; min-width:75px; color:white"
                      @click="(n.dialog = true), $forceUpdate()"
                    >
                      <v-icon dark style="font-size:22px; ">cancel</v-icon>
                      &nbsp;&nbsp; Decline
                    </v-btn>

                    <v-dialog
                      v-model="n.dialog"
                      width="auto"
                      :fullscreen="$vuetify.breakpoint.xsOnly"
                      style="border-radius: 10px; "
                    >
                      <v-card style="background: #b1b0b0;">
                        <v-card-title
                          class="headline grey lighten-2"
                          style="text-transform: capitalize;"
                        >
                          {{ n.title }} - Is Being Declined
                        </v-card-title>

                        <v-card-text style="text-transform: capitalize;">
                          add reasons for being declined
                        </v-card-text>

                        <v-autocomplete
                          v-model="chosenReason"
                          :items="denyAutocomplete"
                          solo
                          dense
                          chips
                          small-chips
                          label="Report Post Reason"
                          :menu-props="menuProps"
                          style="margin: 12px;"
                        >
                          <template slot="selection" slot-scope="data" pa-5>
                            <v-chip
                              text-color="white"
                              :selected="data.selected"
                              close
                              class="primary elevation-4"
                              @input="data.parent.selectItem(data.item)"
                            >
                              {{ data.item }}
                            </v-chip>
                          </template>

                          <template slot="item" slot-scope="data">
                            <v-list-tile-content
                              v-text="data.item"
                            ></v-list-tile-content>
                          </template>
                        </v-autocomplete>

                        <v-textarea
                          v-model="n.msg"
                          solo
                          style="width: 90%; margin: auto"
                        >
                        </v-textarea>

                        <v-divider></v-divider>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="danger"
                            text
                            @click="
                              (n.dialog = false),
                                decline(n.forum_id, n.msg),
                                $forceUpdate()
                            "
                            style="border-radius:20px; color:white"
                          >
                            Decline
                          </v-btn>
                          <v-btn
                            color="primary"
                            text
                            @click="(n.dialog = false), $forceUpdate()"
                            style="border-radius:20px; color:white"
                          >
                            Cancel
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>

                    <!-- stage 2 add upvote vs downvote, first to 5 goes to accept or delete -->
                  </div>

                  <div>
                    <v-chip
                      :key="n.forum_id"
                      style="background-color:black; height:30px; text-transform: capitalize; font-weight:800"
                      text-color="white"
                      @click="$router.push('/profile/' + n.creatorID)"
                      >Creator: {{ n.name }} &nbsp;&nbsp;&nbsp;&nbsp; -
                      &nbsp;&nbsp;&nbsp;&nbsp; {{ n.time }}</v-chip
                    >
                  </div>
                  <div
                    style="overflow-wrap: anywhere; white-space: break-spaces; margin:5px"
                    v-show="n.tags.length > 0"
                  >
                    <template v-for="tag in n.tags">
                      <v-chip
                        :key="tag"
                        class="ma-2 primary elevation-4"
                        style=" height:25px;"
                        text-color="white"
                        >{{ tag }}</v-chip
                      >
                    </template>
                  </div>

                  <div v-show="n.links.length > 0">
                    <template v-for="link in n.links">
                      <v-chip
                        :key="link"
                        class="ma-2 secondary elevation-4"
                        style=" height:25px;"
                        text-color="white"
                        @click="open(link)"
                        >{{ link.match(/([a-zA-z.]*)/)[1] }}</v-chip
                      >
                    </template>
                  </div>
                </v-list>
              </v-layout>
            </v-card>
          </v-card>
        </div>
      </template>
      <div v-show="news.length == 0 && loading == false">
        <div
          class="hidden-sm-and-down"
          style=" text-align: center; background: #6aaafe00; border-radius: 10px; width: 70%; margin: auto; margin-bottom: 20px; height: 120px; padding: 8px;"
        >
          <h1
            style=" color: white; font-size: 40px; font-family: 'Hind', sans-serif;"
          >
            No Posts To Review
          </h1>
        </div>

        <div
          class="hidden-md-and-up"
          style=" text-align: center; background: #6aaafe00; border-radius: 10px; width: 70%; margin: auto; margin-bottom: 20px; height: 80px; padding: 8px;"
        >
          <h1
            style=" color: white; font-size: 23px; font-family: 'Hind', sans-serif;"
          >
            No Posts To Review
          </h1>
        </div>
      </div>
      <div v-show="loading === true && max != true">
        <div class="fingerprint-spinner">
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
          <div class="spinner-ring"></div>
        </div>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

import firebase from "firebase";
import "firebase/firestore";

export default {
  data() {
    return {
      loading: true,
      max: false,
      userEmail: "",
      userID: "",
      name: "",
      avatar: "",
      imageUrl: "",
      updated: "",
      gender: "",
      birthdate: "",
      chosenReason: "",
      denyAutocomplete: [
        "Multiple typos",
        "Inappropriate language, hate speech, racist language, and profanity",
        "Duplicate Post",
        "Extraneous Content",
        "Harassment or Threats",
        "Improperly Cited Information",
        "Copyright Violation",
        "Missing Key Element",
        "Too Disjoint",
        "Design Error",
      ],
      editing: false,
      message: "",
      messageThread: "",
      image: null,
      imageExt: "",
      show: false,
      news: [],
      on: true,
      explore: {
        "1": 1,
      },
      scrolledToBottom: false,
    };
  },
  watch: {
    scrolledToBottom() {
      if (this.scrolledToBottom == true) {
        //search for more news

        this.loading = true;
        this.startSearch();
        this.scrolledToBottom = false;
      }
    },
  },
  computed: {
    ...mapState(["user", "userProfile"]),
  },
  mounted: function() {
    var self = this;
    this.scroll();
    setTimeout(async function() {
      self.userEmail = self.user.email;

      if (!self.userProfile.isAdmin) {
        self.$router.push("/news");
      }

      await self.search();

      if (self.userProfile.updated) {
        self.updated = self.userProfile.updated;
      }
      if (self.userProfile.uid) {
        self.userID = self.userProfile.uid;
      }
      if (self.userProfile.name) {
        self.name = self.userProfile.name;
      }
      if (self.userProfile.gender) {
        self.gender = self.userProfile.gender;
      }
      if (self.userProfile.birthdate) {
        self.birthdate = self.userProfile.birthdate;
      }
      if (self.userProfile.phone) {
        self.phone = self.userProfile.phone;
      }
      if (self.userProfile.avatar) {
        self.avatar = self.userProfile.avatar;
      }
      if (self.userProfile.photoURL) {
        self.imageUrl = self.userProfile.photoURL;
      }
      if (self.userProfile.joined) {
        self.joined = self.userProfile.joined;
      }
      if (self.userProfile.updated) {
        self.updated = self.userProfile.updated;
      }
      if (self.userProfile.imageExt) {
        self.imageExt =
          "https://firebasestorage.googleapis.com/v0/b/mirror2019-b60e0.appspot.com/o/users%2F" +
          self.user.uid +
          self.userProfile.imageExt +
          "?alt=media";
      }
      self.loading = false;
    }, 2000);
  },
  methods: {
    accept(id) {
      // title, files, userID, tag, sources
      var self = this;
      this.news.forEach(function(val) {
        if (val.forum_id == id) {
          self.$store.dispatch("uploadStory", {
            title: val.title.toLowerCase(),
            files: val.itemPath,
            userID: val.creatorID,
            sources: val.links,
            tag: val.tags,
            name: val.name,
            oldforum: id,
          });
        }
      });

      this.removeFromNews(id);
    },
    decline(id, msg) {
      this.$store.dispatch("declineStory", {
        oldforum: id,
        message: msg,
        chosenReason: this.chosenReason,
      });
      this.removeFromNews(id);
    },
    removeFromNews(id) {
      var i = 0;
      for (i = 0; i < this.news.length; i++) {
        if (this.news[i].forum_id == id) {
          this.news.splice(i, 1);
        }
      }
      if (this.news.length == 0) {
        this.$router.push("/news");
      }
    },
    scroll() {
      window.onscroll = () => {
        let bottomOfWindow =
          Math.max(
            window.pageYOffset,
            document.documentElement.scrollTop,
            document.body.scrollTop
          ) +
            window.innerHeight ===
          document.documentElement.offsetHeight;

        if (bottomOfWindow) {
          this.scrolledToBottom = true;
        } else {
          this.scrolledToBottom = false;
        }
      };
    },
    exploreMe(forum_id) {
      this.explore[forum_id] = !this.explore[forum_id];
      this.updateView();
    },
    updateView() {
      this.$forceUpdate();
    },
    open(link) {
      window.open("http://" + link, "_blank");
    },
    async startSearch() {
      await this.search();
      this.loading = false;
    },
    async search() {
      var i = 0;
      var length = 3;
      var j = 0;
      var forum_ids = [];
      var self = this;

      if (this.news) {
        this.news.forEach((val) => {
          if (val.forum_id != undefined) {
            forum_ids.push(val.forum_id);
          }
        });
      }
      while (i < length && !self.max) {
        var snapshot2;
        if (forum_ids.length > 50) {
          snapshot2 = await firebase
            .firestore()
            .collection("userforums")
            .orderBy("time", "desc")
            .limit(100)
            .get();
        } else if (forum_ids.length == 0 || forum_ids > 10) {
          snapshot2 = await firebase
            .firestore()
            .collection("userforums")
            .orderBy("time", "desc")
            .limit(50)
            .get();
        } else {
          snapshot2 = await firebase
            .firestore()
            .collection("userforums")
            .where("forum_id", "not-in", forum_ids)
            .orderBy("forum_id")
            .orderBy("time", "desc")
            .limit(50)
            .get();

          if (snapshot2.size == 0) {
            self.max = true;
            self.loading = false;
            break;
          }
        }

        var d = snapshot2.docs.map((doc) => doc.data());

        if (d.length === 0) {
          self.loading = false;
        }

        d.sort(function(a, b) {
          return b.time - a.time;
        });
        d.forEach(function(doc) {
          j++;
          var bool = true;
          if (forum_ids) {
            forum_ids.forEach((val) => {
              if (val == doc.forum_id && doc.draft == false) {
                bool = false;
              }
            });
          }
          if (bool && i < length && doc.draft == false) {
            var story = doc;
            forum_ids.push(story.forum_id);
            self.news.push(story);
            i++;
          }
        });

        if (j >= 100 || self.max) {
          break;
        }
      }
      const date2 = new Date();

      self.news.forEach(async function(value) {
        if (typeof value.time != "string") {
          value.sortedMessages.sort(function(a, b) {
            if (b.count == a.count) {
              return b.thread.length - a.thread.length;
            }
            return b.count - a.count;
          });
          value.sortedMessages.forEach((value2) => {
            value2.thread.sort(function(a, b) {
              return b.count - a.count;
            });
          });

          value.chat = true;
          value.dialog = false;
          value.msg = "";
          value.index = 0;

          value.explore = false;
          self.explore[value.forum_id] = false;

          const diffTimes = date2.getTime() - value.time;
          const diffDayss = Math.floor(diffTimes / (1000 * 60 * 60 * 24));
          if (diffDayss < 1) {
            var diff = (date2.getTime() - value.time) / 1000;
            diff /= 60 * 60;
            if (diff < 1) {
              var minutes = Math.floor(diff * 60);
              if (Math.abs(Math.round(minutes)) == 1) {
                value.time = Math.abs(Math.round(minutes)) + " minute ago";
              } else {
                value.time = Math.abs(Math.round(minutes)) + " minutes ago";
              }
            } else {
              if (Math.abs(Math.round(diff)) == 1) {
                value.time = 1 + " hour ago";
              } else {
                value.time = Math.abs(Math.round(diff)) + " hours ago";
              }
            }
          } else {
            if (diffDayss == 1) {
              value.time = diffDayss + " day ago";
            } else if (diffDayss >= 7) {
              value.time = new Date(value.time).toDateString();
              value.time =
                value.time.substring(3, 10) + "," + value.time.substring(10);
            } else {
              value.time = diffDayss + " days ago";
            }
          }

          value.sortedMessages.forEach((value2) => {
            const diffTime = date2.getTime() - value2.time;
            const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
            if (diffDays < 1) {
              var diff = (date2.getTime() - value2.time) / 1000;
              diff /= 60 * 60;
              if (diff < 1) {
                var minutes = Math.floor(diff * 60);
                if (Math.abs(Math.round(minutes)) == 1) {
                  value2.time = Math.abs(Math.round(minutes)) + " minute ago";
                } else {
                  value2.time = Math.abs(Math.round(minutes)) + " minutes ago";
                }
              } else {
                if (Math.abs(Math.round(diff)) == 1) {
                  value2.time = 1 + " hour ago";
                } else {
                  value2.time = Math.abs(Math.round(diff)) + " hours ago";
                }
              }
            } else {
              if (diffDays == 1) {
                value2.time = diffDays + " day ago";
              } else if (diffDays >= 7) {
                value2.time = new Date(value2.time).toDateString();
                value2.time =
                  value2.time.substring(3, 10) +
                  "," +
                  value2.time.substring(10);
              } else {
                value2.time = diffDays + " days ago";
              }
            }

            value2.thread.forEach((value3) => {
              const diffTime = Math.abs(date2 - value3.time);
              const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
              if (diffDays < 1) {
                var diff = (date2.getTime() - value3.time) / 1000;
                diff /= 60 * 60;
                if (diff < 1) {
                  var minutes = Math.floor(diff * 60);
                  if (Math.abs(Math.round(minutes)) == 1) {
                    value3.time = Math.abs(Math.round(minutes)) + " minute ago";
                  } else {
                    value3.time =
                      Math.abs(Math.round(minutes)) + " minutes ago";
                  }
                } else {
                  if (Math.abs(Math.round(diff)) == 1) {
                    value3.time = 1 + " hour ago";
                  } else {
                    value3.time = Math.abs(Math.round(diff)) + " hours ago";
                  }
                }
              } else {
                if (diffDays == 1) {
                  value3.time = diffDays + " day ago";
                } else if (diffDayss >= 7) {
                  value3.time = new Date(value3.time).toDateString();
                  value3.time =
                    value3.time.substring(3, 10) +
                    "," +
                    value3.time.substring(10);
                } else {
                  value3.time = diffDays + " days ago";
                }
              }
            });
          });

          if (value.items.length == 0) {
            await firebase
              .storage()
              .ref(value.itemPath)
              .listAll()
              .then(function(res) {
                var arr = [];

                for (var i = 0; i < res.items.length; i++) {
                  arr.push[""];
                }

                res.items.forEach(function(itemRef) {
                  var starsRef = firebase.storage().ref(itemRef.fullPath);
                  // Get the download URL
                  starsRef.getDownloadURL().then(function(url) {
                    const index = parseInt(itemRef.name);
                    value.items[index] = url;
                    self.$forceUpdate();
                  });
                });
              });
          }
        }
      });

      var unique = [];

      this.news.forEach(function(val) {
        var bool = false;
        if (unique.length > 0) {
          unique.forEach(function(val2) {
            if (val2.forum_id == val.forum_id) {
              bool = true;
            }
          });
        }
        if (!bool) {
          unique.push(val);
        }
      });
      this.news = unique;
    },
  },
};
</script>
